<template>
	<svg viewBox="0 0 32 32">
		<path d="M9.114 7.757l15.839 15.839-1.131 1.131-15.839-15.839 1.131-1.131z" />
		<path d="M23.822 7.757l1.131 1.131-15.839 15.839-1.131-1.131 15.839-15.839z" />
		<path d="M4.686 27.314c-6.223-6.223-6.223-16.405 0-22.627s16.405-6.223 22.627 0 6.223 16.405 0 22.627-16.405 6.223-22.627 0zM26.182 5.818c-5.657-5.657-14.708-5.657-20.365 0s-5.657 14.708 0 20.365 14.708 5.657 20.365 0 5.657-14.708 0-20.365z" />
	</svg>
</template>
